<!-- 商品查询 -->
<template>
<div class="page-form">
    <PageBack :title="title" />
    <div class="detail-wrap">
        <el-form :model="searchForm" ref="searchForm"  :inline="true"> 
            <el-form-item label="名称" prop="productName">
                <el-input style="width: 200px;" v-model="searchForm.productName"></el-input>
            </el-form-item>   
            <el-form-item label="分类" prop="certType">
                <el-select v-model="searchForm.certType" style="width: 100%;">
                    <el-option 
                        v-for="item in typeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>                   
            <el-form-item label="状态" prop="status">
                <el-select v-model="searchForm.status" style="width: 100%;">
                    <el-option 
                        v-for="item in statusOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>
                <el-button @click="resetForm('searchForm')">重置</el-button>
                <el-button type="success" @click="handleAdd" v-if="adminRoles">添加商品</el-button>
            </el-form-item>          
        </el-form>
        <el-table border :data="tableData" style="width: 100%;">
            <el-table-column  prop="index"   label="序号"   width="50" align="center"/>     
            <el-table-column  prop="productName"  label="名称" width="120"  align="center"/>                
            <el-table-column  prop="categoryName"   label="类别" width="120" align="center"/>
            <el-table-column  prop="mainImageUrl"   label="主图" width="120" align="center" >
                <template slot-scope="scope">
                    <span v-if="scope.row.mainImageUrl===''">暂无</span>
                    <el-image :src="scope.row.mainImageUrlLink" :preview-src-list="scope.row.srcList" v-else></el-image>
                </template>              
            </el-table-column>
            <el-table-column  prop="des"  label="详情"  align="center"/>
            <el-table-column  prop="issueDateFormat"  label="上架日期"  align="center" width="120"/>
            <el-table-column  prop="status"  label="状态" align="center"  width="80"/>
            <el-table-column  fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleUpOrDown(scope.row)" type="text" 
                    size="small" v-if="roles==='管理员'">{{ scope.row.statusValue ==='1'?'下架': '上架' }}</el-button>
                    <el-button @click="handleUpdate(scope.row)" type="text" 
                    size="small" v-if="roles==='管理员'">编辑</el-button>
                    <el-button @click="handleCancel(scope.row)" type="text" 
                    size="small" v-if="roles==='管理员'">刪除</el-button>
                    <el-button @click="handleSettingSpec(scope.row)" type="text" 
                    size="small" v-if="roles==='管理员'">设置规格</el-button>
                    <el-button @click="handleLookSpec(scope.row.productId)" type="text" 
                    size="small" v-if="roles==='管理员'">查看规格</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination
            style="text-align:right"
            v-show="total > 10"
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pagesize"
            @pagination="initData"
        />
        <AddGoods :title="goodsDialogTitle" 
            v-if="isShowGoods"
            :formData="goodsForm" 
            @close="closeDialog"
            ref="childComponentRef"
            @confirm="handleConfirm"></AddGoods>

        <AddSpec :title="goodsSpecDialogTitle" 
            v-if="isShowGoodsSpec"
            :formData="goodsSpecForm" 
            @close="closeDialog"
            ref="childComponentSpecRef"
            @confirm="handleConfirmSpec"></AddSpec>
        
        <SpecDetailDraw 
            v-if="isShowGoodsSpecDetail"
            :formData="goodsSpecDetailForm"
            @close="closeDialog"
            @confirm="handleConfirmSpecDetail"></SpecDetailDraw>
    </div>
</div>
</template>

<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
import AddGoods from './components/addGoods'
import AddSpec from './components/addSpec'
import SpecDetailDraw from './components/specDetailDraw'
export default {
    components: {
        PageBack,
        pagination,
        AddGoods,
        AddSpec,
        SpecDetailDraw
    },
    data() {
        return {
            isShowGoods: false,
            isShowGoodsSpec: false,
            isShowGoodsSpecDetail: false,
            searchForm:{
                productName: '',
                certType: '',
                status: ''
            },
            queryParams:{
                page: 1,
                pagesize: 10
            },
            tableData: [],
            statusOption: [
                {value:'', label:'全部'},
                {value:'1', label:'上架'},
                {value:'2', label: '下架'},
            ],
            total: 0,
            typeOption: [
                {label: '掼蛋产品',value: '1'}
            ],
            isDialogVisible: false,
            titleForm: '',
            goodsForm: {},
            goodsSpecForm: {},
            goodsSpecDetailForm: [],
            goodsDialogTitle: '',
            goodsSpecDialogTitle: ''
        }
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
        roles(){
            return localStorage.getItem('roles')
        }, 
        adminRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        }, 
    },
    created() {
        
    },
    mounted() {
        // this.getType()

        this.initData()
    },
    methods: {
        getType(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 110,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.typeOption = arr.map(item=>{
                        return{
                            label: item['中文描述'],
                            value: item['词条索引']
                        }
                    })
                }
            })
        },
        initData(){
            let params = {
                opcode: this.$code.GoodsQuery,
                v_goods_classify: '',
                v_goods_serial: '',
                v_goods_title: '',
                c_status: '',
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page
            }

            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let arr = res.Data.DataTable
                    this.total = res.Data.SumCount
                    if(arr.length > 0){
                        this.tableData = arr.map(item=>{
                            let  mainImageUrl = item['封面主图']  
                            let mainImageUrlLink = ''  
                            let linkArray = []                   
                            if(mainImageUrl !== '' && mainImageUrl.indexOf(',') !== '-1'){
                                let imageNames = mainImageUrl.split(',')
                                
                                const imageObjects = imageNames.map((name,index) =>{
                                    return this.$global.uploadUrl  + name                                    
                                })
                                mainImageUrlLink = imageObjects[0]
                                linkArray = imageObjects
                            }else{
                                if(mainImageUrl !== ''){
                                    mainImageUrlLink = item['封面主图'] ? this.$global.uploadUrl + item['封面主图']: ''
                                    linkArray = [mainImageUrlLink]
                                }
                            }
                            return{
                                index: item['序号'],
                                productName: item['商品标题'],
                                subName: item['商品副标题'],
                                productId: item['商品标识'],
                                isDefault: item['是否置顶'],
                                postage: item['邮费'],
                                des: item['详情'],
                                userId: item['上架人员账号'], 
                                username: item['上架人员'],  
                                issueDate: item['上架日期'],                                 
                                issueDateFormat: this.$help.formatDate(item['上架日期']), 
                                updateIssueDate: this.$help.formatDate(item['更新日期']), 
                                category: item['商品分类'],
                                categoryName: this.certTypeToText(item['商品分类']),
                                status: item['商品状态'],
                                statusValue: item['商品状态'] === '上架'? '1' : '2',
                                deliverRules:item['发货规则'],
                                refundRules: item['退换货规则'],
                                imageTextUrl: item['图文详情'],
                                // detailImageUrl: item['封面主图1'],
                                mainImageUrl: mainImageUrl,
                                mainImageUrlLink: mainImageUrlLink,
                                srcList: linkArray
                            }
                        })
                    }else{
                        this.tableData = []
                    }
                }
            })
        },
        searchQuery(){            
            if(this.roles === '管理员'){
                this.initData()
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        handleAdd(){
            this.isShowGoods = true
            this.goodsDialogTitle = '添加商品'
            this.goodsForm = {}
        },
        // 更新
        handleUpdate(obj){           
            this.isShowGoods = true
            this.goodsDialogTitle = '更新商品'
            this.goodsForm = obj
        },
        // 删除
        handleCancel(obj){
            this.$confirm('确定删除商品吗？','警告',).then(res=>{
               this.confirmDelete(obj)
            }).catch(err=>{
                console.log(err)
            })
        },
        confirmDelete(obj){         
            let params = {
                opcode: this.$code.DeleteGoods,
                v_goods_serial: obj.productId
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.$message.success('删除商品成功')
                    this.initData()            
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        certTypeToText(value){
            let arr  = this.typeOption.filter(i=>i.value === value)
            return arr[0].label
        },
        handleConfirm(){
            this.initData()
        },
        closeDialog(){
            this.isShowGoods = false
            this.isShowGoodsSpec = false
            this.isShowGoodsSpecDetail = false
        },
        handleUpOrDown(row){
            if(row.status === '下架'){
                console.log('上架')
                //上架的接口
                this.$confirm('确定上架商品吗？','警告',).then(res=>{
                    this.goodsUpDownShelf(row,1)
                }).catch(err=>{
                    console.log(err)
                })
            }else{
                console.log('下架')
                //下架的接口
                this.$confirm('确定下架商品吗？','警告',).then(res=>{
                    this.goodsUpDownShelf(row,2)
                }).catch(err=>{
                    console.log(err)
                })
            }
        },  
        // 上下架的方法
        goodsUpDownShelf(row,status){
            let params = {
                opcode: this.$code.UpDownShelf,
                v_goods_serial: row.productId,
                v_summary: status
            }   
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let message = status === 1 ? '上架商品成功': '下架商品成功'
                    this.$message.success(message)
                    this.initData()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },       
        // 设置规格
        handleSettingSpec(row){
            console.log(row)
            this.isShowGoodsSpec = true
            this.goodsSpecDialogTitle = '添加规格'
            this.goodsSpecForm = {
                productId: row.productId
            }
        },
        handleConfirmSpec(){
            this.initData()
        },
        goodsSpecDetail(id){
            let params = {
                opcode: this.$code.GoodsSpec,
                v_goods_serial: id,
                i_norms_serial: 0,
                pagesize: 10,
                size:1,
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){                  
                    let arr = res.Data.DataTable
                    
                    if(arr.length > 0){                        
                        this.goodsSpecDetailForm = arr.map(item=>{
                            let  mainImageUrl = item['商品规格图片']
                            let  detailImageUrl =  item['商品规格图片1']
                            return{
                                index: item['序号'],
                                productName: item['商品规格标题'],
                                subName: item['商品规格副标题'],
                                productId: item['商品标识'],
                                productSpecId: item['商品规格标识'],
                                isDefault: item['是否置顶'],
                                productPrice: item['价格'],
                                productQuality: item['数量'],
                                size: item['尺寸'],
                                colour: item['颜色'],
                                material: item['材质'], 
                                weight: item['重量'],   
                                productMode:item['库存策略'],
                                limitQuality: item['限购设置'],
                                des: item['商品规格详情'],                                
                                mainImageUrl: mainImageUrl,
                                detailImageUrl:detailImageUrl,                                
                            }
                        })
                        this.isShowGoodsSpecDetail = true
                    }else{
                        this.goodsSpecDetailForm = []
                        this.isShowGoodsSpecDetail = true
                    }
                }
            })
        },
        handleLookSpec(id){        
            // this.goodsSpecDetail(id)
            this.$router.push({
                path: 'specDetail',
                query: {
                    id:id
                }
            })
        },
        handleConfirmSpecDetail(id){
            console.log(id)
            this.goodsSpecDetail(id)
        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/product/product.vue